<div class="container h-100 canvas-page">
    <div *ngIf="isLoading == true" class="row h-100 justify-content-center align-items-center">
        <div class="text-center">
            <app-loading-spinner></app-loading-spinner>
        </div>
    </div>
    <div class="row justify-content-center align-items-center VerticalMargin mb-5"
        [ngClass]="isLoading == false ? 'visible' : 'hidden'">
        <div class="card RegularForm rounded col-11 canvas-panel" 
            [class.SmallArabicFont]="globalService.isRTL == true">
            <div class="card-body MyCardBody rounded-bottom" *ngIf="result != null">
                <div id="MyDIv" class="main-container">
                    <div class="text-right mb-4">
                        <img class="slimbar" src="{{ logoSource }}" crossorigin="*" width="60" height="60" />
                        <div class="badge text-wrap" [class.text-right]="globalService.isRTL == true"
                            [class.text-left]="globalService.isRTL == false"
                            [class.longName]="globalService.isRTL == false"
                            [class.longNameArabic]="globalService.isRTL == true" style="width: 10rem"
                            [class.ArabicFont]="globalService.isRTL == true">
                            {{ churchName }}
                        </div>
                    </div>
                    <h2 class="text-center mb-4"><strong> TAX STATEMENT </strong></h2>
                    <small>Contributor Name: </small>
                    <small><strong>{{result.firstName}} {{result.lastName}}</strong></small><br>
                    <small>To: <strong> {{ churchName }}</strong> - TAX ID: <strong>{{ taxId}}</strong></small><br>
                    <small>Contribution Period: <strong> {{ period }} </strong></small><br>
                    <small>Total Contribution:</small>
                    <small><strong> {{ total | currency }}</strong></small><br><br>
                    <small>No goods or services were provided in exchange of your contributions listed below:</small><br>
                    <br><br>
                    <table class="table table-striped entity-list-table">
                        <thead>
                            <tr>
                                <td scope="col"><small>Date</small></td>
                                <td scope="col"><small>Amount</small></td> 
                                <td scope="col"><small>Fund</small></td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let donation of data; let idx = index">
                                <td><small> {{ donation.donationDate | date: 'M/d/yy' }}</small></td>
                                <td><small> {{ donation.donationAmount | currency }}</small></td>
                                <td><small> {{ donation.givingType }}</small></td>
                            </tr>
                        </tbody>
                    </table>
                    <br> 
                    <small> Thank you for your contribution.</small>
                    <br><br>
                    <small> Treasurer </small><br>
                    <small><strong> {{ churchName }}</strong></small><br>
                    <small><strong> {{ currentDate | date: 'MM/dd/yyyy'}}  </strong></small><br><br>
                </div>
                <div class="row">
                    <div class="col-12 mt-4 text-center">
                        <button [class.pt-2]="globalService.isRTL == true"
                            class="btn optionButton btn-primary btn-block"
                            [class.mr-2]="globalService.isRTL == false" [class.ml-2]="globalService.isRTL == true"
                            type="button" (click)="exportAsPDF('MyDIv')">
                            Download As PDF <i class="fas fa-file-pdf ml-2"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>